import { useState, useRef, useEffect } from "react"
import {points_1_str, points_2_str, points_3_str, points_heart_str}  from "./card.js"

function str_to_points(str) {
    return str.trim().split("\n").map( line => {
        const [x_str, y_str] = line.split(",")
        return [parseFloat(x_str), parseFloat(y_str)]
    } )
}

const points_1 = str_to_points(points_1_str).map(xy => [xy[0], xy[1], "red"])
const points_2 = str_to_points(points_2_str).map(xy => [xy[0], xy[1], "blue"])
const points_3 = str_to_points(points_3_str).map(xy => [xy[0], xy[1], "green"])
const points_heart = str_to_points(points_heart_str).map(xy => [xy[0], xy[1], "red"])


const drawPoint = (ctx, x,y, r=0.5) => {
    ctx.beginPath()
    ctx.arc(x, y, r, 0, 2*Math.PI)
    ctx.fill()
}

const Canvas = (props) => {
    const canvasRef = useRef(null)
    
    

    const updateCanvas = (props) => {
        const canvas = canvasRef.current
        if(!canvas) { return  }
        const dpr = window.devicePixelRatio || 2
        const rect = canvas.getBoundingClientRect()
        // canvas.width = 200 //rect.width * dpr
        canvas.width = Math.max(...points.map(xy => xy[0]))
        canvas.height = Math.max(...points.map(xy => xy[1]))
        const ctx = canvas.getContext("2d")
        ctx.scale(dpr, dpr)
        ctx.fillStyle = "black"
        props.points.slice(0, props.id).forEach(xy => {
            ctx.fillStyle = xy[2]
            drawPoint(ctx, xy[0], xy[1], 1)            
        });
    }

    useEffect(() => updateCanvas(props),)

    return(
        <div>
            <h2>This is my canvas, id={props.id}, [points]={props.points.length}</h2>
            <canvas ref={canvasRef} style={{border:"1px solid black", 
                width:"50%", height:"50%"}}>
            </canvas>
        </div>
    )

}

const generateNormalPoints = (count, centerX = 50, centerY = 50, stdDev = 20) => {
    const points = []
    for (let i = 0; i < count; i++) {
        // Box-Muller transform for normal distribution
        
        const x = i % 200
        const y = (10 + 10*i)/600
        
        points.push([x, y])
    }
    return points
}


// const points = [...points_1, ...points_2, ...points_3, ...points_heart]
const points = generateNormalPoints(10000).map(xy => [xy[0], xy[1], "red"])

const CanvasComponent = () => {
    const [id, setId] = useState(1);
    const [running, setRunning] = useState(true);

    useEffect(() => {
        if (!running) return;

        const intervalId = setInterval(() => {
        setId(prev => prev + 1);
        if(id > points.length) { setRunning(0)}
        }, 1);

        return () => clearInterval(intervalId);
    }, [id, running]);

    const handleClack = () => {
        if(id < points.length) {
            setRunning(1-running)
        }
        else {
            setId(0); setRunning(1)
        }
    }

    return (
        <div>
        <div>id = {id}</div>

        <button onClick={() => setId(prev => prev + 1)}>Step</button>
        <button onClick={() => setRunning(r => !r)}>
            {running ? "Pause" : "Resume"}
        </button>
        <button onClick={() => console.log("points=", points)}>Points</button>
        <div onDoubleClick={() => {console.log("Clicked"); setId(0);}}
            onClick = {handleClack}>
            <Canvas id={id} points={points} />
        </div>
        </div>
    );
};

export default CanvasComponent;
